import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n,
} from "@/composables/useI18n";

import {
  FloatingActionButton
} from '@/components/buttons';

import {
  InformationDialog
} from '@/components/base';

import type {
  GratificationSettings
} from '@/components/settings/scripts/Gratification';

import type {
  ErrorResultState,
  RefStates
} from '@/scripts/States/types';

import {
  fetchGratificationSettings,
  updateGratificationSettings,
  isInCardLimite,
  hasCorrectDecimals,
  hasValue,
  isPositivNumber
} from '@/components/settings/scripts/Gratification'

import {
  PropType,
  computed,
  onMounted,
  ref,
  watch,
  unref
} from 'vue'

import type {
  CardLimite,
} from "@/components/settings/scripts/CardLimite";

import {
  fetchCardLimite,
} from "@/components/settings/scripts/CardLimite";

import {
  copyObject,
} from "@/scripts/Common/HelperFunctions";

import {
  hasAccessRights,
} from "@/authorization/AuthorizationService";

import {
  editSettingsPolicy,
} from "@/authorization/policies";


export default /*#__PURE__*/_defineComponent({
  __name: 'GratificationSettings',
  props: {
  token: {
    required: true,
    type: String as PropType<string>,
  }
},
  setup(__props) {

const props = __props;


onMounted(async () => {
  await loadGratificationSettings();
  await loadCardLimite();
  refStates.value.isLoading = false;
});

const gratificationForm = ref();

const enabledSelections = computed(() => [
  {state: t('states.enabled'), value: true},
  {state: t('states.disabled'), value: false}
]);

const settingsHaveChanges = () =>  {
  return gratificationSettings.value.enabled !== serverGratificationSettings.value?.enabled
      || gratificationSettings.value.maximumAnnualCount !== serverGratificationSettings.value?.maximumAnnualCount
      || gratificationSettings.value.maximumAmountPerCharge !== serverGratificationSettings.value?.maximumAmountPerCharge;
};

const {
  t,
  tc,
} = useI18n();

const tabs = null;

const informationDialog = ref<InstanceType<typeof InformationDialog>>()

const serverGratificationSettings = ref<GratificationSettings>();
const gratificationSettings = ref<GratificationSettings>({
  enabled: false,
  maximumAnnualCount: 0,
  maximumAmountPerCharge: 0
});

const refStates = ref<RefStates>({
  hasChanges: false,
  canSave: false,
  isLoading: true
})

const cardLimite = ref<CardLimite>({
  minCardLimit: 0,
  maxCardLimit: 0,
  maxMonthlyTopUpAmount: 0,
  topUpLimitPerMonth: 0
});

const errorResponse = ref<ErrorResultState>({
  hasError: false,
  errorCode: 0,
  errorMessage: ""
})



const loadErrorDialog = () => informationDialog.value?.Show();

const loadGratificationSettings = async () => {
  const { response } = await fetchGratificationSettings(props.token);

  if(response){
    gratificationSettings.value = response;
    serverGratificationSettings.value = copyObject(response);
    return
  }

  errorResponse.value.errorMessage = t("errors.unknown");
  loadErrorDialog();
}

const loadCardLimite = async () => {
  const { response } = await fetchCardLimite(props.token)

  if(response){
    cardLimite.value = response;
    cardLimite.value.minCardLimit = 0;
    return
  }

  errorResponse.value.errorMessage = t("errors.cardLimite");
  loadErrorDialog();
}

const updateGratifications = async () => {
  const {
    response,
    errorCode
  } = await updateGratificationSettings(props.token, unref(gratificationSettings));

  if(response){
    gratificationSettings.value = response;
    serverGratificationSettings.value = copyObject(response);
    resetHaveChanges()
    return
  }

  errorCode === 400
      ? errorResponse.value.errorMessage = t("errors.validation")
      : errorResponse.value.errorMessage = t("errors.unknown");

  loadErrorDialog();
}

const resetChanges = async () => {
  resetHaveChanges()
  refStates.value.isLoading = true;
  await loadGratificationSettings()
  refStates.value.isLoading = false;
}

const resetHaveChanges = () => {
  refStates.value.hasChanges = false;
}

const validate = () => {
  gratificationForm.value.validate();
}

const resetErrorStates = () => {
  errorResponse.value.hasError = false;
  errorResponse.value.errorCode = 0;
  errorResponse.value.errorMessage = ""
}

watch(() => gratificationSettings.value, () => {
  if(!settingsHaveChanges()){
    resetHaveChanges();
    return;
  }
  refStates.value.hasChanges = true;
},{deep: true});


return { __sfc: true,gratificationForm, enabledSelections, settingsHaveChanges, t, tc, tabs, informationDialog, serverGratificationSettings, gratificationSettings, refStates, cardLimite, errorResponse, props, loadErrorDialog, loadGratificationSettings, loadCardLimite, updateGratifications, resetChanges, resetHaveChanges, validate, resetErrorStates, FloatingActionButton, InformationDialog, isInCardLimite, hasCorrectDecimals, hasValue, isPositivNumber, unref, hasAccessRights, editSettingsPolicy }
}

})